/* Cart Drawer — open/close + AJAX add/update */

/* Textos traducidos publicados por snippets/cart-drawer.liquid. Se leen en cada
   llamada porque refresh() reemplaza el nodo (y su bloque de strings). */
function cartDrawerStrings() {
  const el = document.querySelector('[data-cart-drawer-strings]');
  let parsed = {};
  if (el) {
    try { parsed = JSON.parse(el.textContent) || {}; } catch (e) { parsed = {}; }
  }
  return {
    adding: parsed.adding || 'Adding...',
    addingShort: parsed.addingShort || 'Adding',
    added: parsed.added || 'Added',
  };
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.body = this.querySelector('[data-cart-body]');
    this.onKeydown = this.onKeydown.bind(this);
  }
  connectedCallback() {
    if (this.isInitialized) return;
    this.isInitialized = true;

    this.querySelectorAll('[data-cart-close]').forEach((el) =>
      el.addEventListener('click', () => this.close())
    );
    this.addEventListener('click', (e) => {
      const quickBuyBtn = e.target.closest('[data-quick-buy]');
      if (quickBuyBtn) {
        e.preventDefault();
        e.stopPropagation();
        this.quickBuy(quickBuyBtn);
        return;
      }
      const upsellBtn = e.target.closest('[data-cart-upsell-add]');
      if (upsellBtn) {
        e.preventDefault();
        this.addUpsell(upsellBtn);
        return;
      }
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        const item = removeBtn.closest('[data-cart-item]');
        if (item) this.changeItem(item.dataset.key, 0);
      }
      const qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        const item = qtyBtn.closest('[data-cart-item]');
        const delta = parseInt(qtyBtn.dataset.qtyChange, 10);
        const current = parseInt(item.querySelector('[data-qty]').textContent, 10) || 0;
        this.changeItem(item.dataset.key, Math.max(0, current + delta));
      }
    });
    document.addEventListener('keydown', this.onKeydown);
  }
  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
  }
  onKeydown(e) {
    if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
  }
  open() {
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }
  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }
  async changeItem(key, quantity) {
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!r.ok) throw new Error('change failed');
      await this.refresh();
    } catch (err) {
      console.error('[cart-drawer]', err);
    }
  }
  async quickBuy(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;
    if (button.disabled) return;
    const original = button.textContent;
    button.disabled = true;
    button.textContent = '...';
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      });
      if (!r.ok) throw new Error('quick-buy failed');
      await this.refresh();
      // refresh() can replace this node, so re-query and open the live one
      document.querySelector('cart-drawer')?.open();
    } catch (err) {
      console.error('[quick-buy]', err);
      button.disabled = false;
      button.textContent = original;
    }
  }
  async addUpsell(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;
    const label = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = cartDrawerStrings().addingShort;
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!r.ok) throw new Error('upsell add failed');
      await this.refresh();
      document.querySelector('cart-drawer')?.open();
    } catch (err) {
      console.error('[cart-upsell]', err);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = label;
    }
  }
  async refresh() {
    const wasOpen = this.classList.contains('is-open');
    let liveDrawer = this;

    const html = await fetch('/?cart-drawer=1').then((x) => x.text()).catch(() => null);
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('cart-drawer');
      if (next) {
        this.replaceWith(next);
        liveDrawer = document.querySelector('cart-drawer') || next;
        if (wasOpen && typeof liveDrawer.open === 'function') liveDrawer.open();
      }
    }

    // Update header counter
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((x) => x.json());
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
        const badge = el.closest('.onedilemma-header__cart-badge');
        if (badge) badge.style.display = cart.item_count > 0 ? '' : 'none';
      });
    } catch {}

    return liveDrawer;
  }
}
if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

// Global open helper + cart link interception
if (!window.__onedilemmaCartDrawerListeners) {
  window.__onedilemmaCartDrawerListeners = true;

document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-cart-toggle], a[href="/cart"], a[href$="/cart"]');
  if (!opener) return;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  e.preventDefault();
  drawer.open();
});

// Intercept add-to-cart forms
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[action*="/cart/add"]');
  if (!form) return;
  e.preventDefault();
  if (form.dataset.comingSoon === 'true') return;
  if (form.dataset.cartSubmitting === 'true') return;
  form.dataset.cartSubmitting = 'true';

  const submitButton = form.querySelector('[type="submit"]');
  const submitText = submitButton?.querySelector('[data-atc-text]') || submitButton?.querySelector('span');
  const originalText = submitText?.textContent;
  const wasDisabled = submitButton?.disabled;

  if (submitButton) {
    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');
    submitButton.classList.add('is-loading');
  }
  if (submitText) submitText.textContent = cartDrawerStrings().adding;

  const data = new FormData(form);
  try {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data,
    });
    if (!r.ok) throw new Error('add failed');
    if (submitText) submitText.textContent = cartDrawerStrings().added;
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const liveDrawer = typeof drawer.refresh === 'function' ? await drawer.refresh() : drawer;
      if (liveDrawer && typeof liveDrawer.open === 'function') liveDrawer.open();
    }
    document.dispatchEvent(new CustomEvent('cart:updated'));
  } catch (err) {
    console.error('[cart-add]', err);
    form.submit();
    return;
  } finally {
    form.dataset.cartSubmitting = 'false';
    if (submitButton) {
      submitButton.disabled = wasDisabled;
      submitButton.removeAttribute('aria-busy');
      submitButton.classList.remove('is-loading');
    }
    if (submitText && originalText) {
      window.setTimeout(() => {
        submitText.textContent = originalText;
      }, 700);
    }
  }
});
}
